import { createAction } from '@reduxjs/toolkit';
import {
  LoginReq,
} from 'types/requests';
import actionTypes from './actionTypes';

export const login = createAction<LoginReq>(actionTypes.LOGIN);
